<template>
  <div >
    <el-form :model="ruleForm" class="formpanel" status-icon :rules="rules" ref="ruleForm" label-width="100px">
      <el-form-item label="密码" prop="pass">
        <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="重复密码" prop="checkPass">
        <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div style="display: flex;flex-flow: row;justify-content: flex-end;">
      <el-button class="formpanelbtn" type="primary" icon="el-icon-edit" @click="submitForm('ruleForm')">立即注册</el-button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import Utils from '../../util/utils'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'CReSetPW',
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        yzmabled: false,
        ruleForm: {
          pass: '',
          checkPass: ''
        },
        rules: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
      };
    },
    mounted: function () {
      that = this
      /* 获取是否通过手机验证 */
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
            var adata = {
              username: localStorage.getItem('username'),
              password: this.ruleForm.pass,
              userimg: '',
              regtime: addtime,
              cususerid: '0'
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/account/aaubai',
              method: 'post',
              data: adata,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  var tmpdata = '[{"Id":"318","AppID":"5","Name":"新用户配置","ParentID":"-1","Level":0,"HasChild":1,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"319","AppID":"5","Name":"我的","ParentID":"318","Level":1,"HasChild":1,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"324","AppID":"5","Name":"用户资料","ParentID":"319","Level":2,"HasChild":1,"Icon":{"String":"fa fa-indent","Valid":true},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"345","AppID":"5","Name":"账号信息","ParentID":"324","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"UserBaseInfo","Valid":true},"Leaf":"true","Children":null},{"Id":"346","AppID":"5","Name":"账号升级","ParentID":"324","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"CompleteInfo","Valid":true},"Leaf":"true","Children":null}]},{"Id":"328","AppID":"5","Name":"系统配置","ParentID":"319","Level":2,"HasChild":1,"Icon":{"String":"fa fa-indent","Valid":true},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"348","AppID":"5","Name":"短信配置","ParentID":"328","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"SMSSet","Valid":true},"Leaf":"true","Children":null},{"Id":"349","AppID":"5","Name":"支付配置","ParentID":"328","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"PaySet","Valid":true},"Leaf":"true","Children":null}]},{"Id":"329","AppID":"5","Name":"功能扩展","ParentID":"319","Level":2,"HasChild":1,"Icon":{"String":"fa fa-indent","Valid":true},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"351","AppID":"5","Name":"功能管理","ParentID":"329","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"AddModel","Valid":true},"Leaf":"true","Children":null}]}]}]}]'
                  var atmpdata = {
                    userid: parseInt(res.data.data),
                    models: tmpdata,
                    cusid: parseInt(1)
                  }
                  that.$http({
                    url: 'https://api.sqnetsoft.cn/permission/aaupu',
                    method: 'post',
                    data: atmpdata,
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  })
                    .then(function (res) {
                      if (res.data.success) {
                        localStorage.setItem('accountid',res.data.data)
                        localStorage.setItem('username',that.phone)
                        that.$router.push({path: '/'})
                      }
                    })
                    .catch(function (error) {
                      window.console.log('error' + error)
                    })
                  // that.$router.push({path: '/'})
                }
              })
              .catch(function (error) {
                window.console.log('error' + error)
              })
          } else {
            return false;
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regedit/SaveAccount.vue